export default "__VITE_ASSET__BihdnU8K__"